import { useState, useEffect, useRef } from "react";
import gsap from "gsap";
import { socialMedia, menu, logo } from "../../utils/index.js";
import { FaTimes } from "react-icons/fa";
import "./navbar.css";

const Navbar = () => {
  const navbarRef = useRef();
  const [mobile_menu, setMobile_menu] = useState(false);

  const openMenuAnimation = () => {
    setMobile_menu((prevMobileMenu) => {
      const newMobileMenu = !prevMobileMenu;

      if (newMobileMenu) {
        window.document.body.style.overflow = "hidden";
      } else {
        window.document.body.style.overflow = "unset";
      }

      return newMobileMenu; // Update state correctly
    });
  };

  const handleNavLinkClick = (e, targetId) => {
    e.preventDefault();

    // Close mobile menu if open
    if (mobile_menu) {
      setMobile_menu(false);
      window.document.body.style.overflow = "unset";
    }

    // Smooth scroll to the section
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const navbar = navbarRef.current;
    let lastScrollY = window.scrollY;
    let isScrolling;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      // Add class to navbar when scrolling down
      if (currentScrollY <= 0) {
        navbar.children[0].classList.remove("show_bg");
      } else {
        navbar.children[0].classList.add("show_bg");
      }
      // hide and show navbar when scrolling down or up
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        // Scrolling Down
        gsap.to(navbar, { y: "-100%", duration: 1, ease: "power2.out" });
      } else if (currentScrollY < lastScrollY) {
        // Scrolling Up
        gsap.to(navbar, { y: "0%", duration: 1, ease: "power2.out" });
      }
      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(isScrolling); // Clear timeout on cleanup
    };
  }, []);

  return (
    <>
      <nav className="nav_outer" ref={navbarRef}>
        <div className="nav">
          <a href="/" className="logo">
            <img src={logo} alt="logo" />
          </a>
          <div className="menu_container">
            <ul className="nav_list">
              <li>
                <a
                  href="#top_projects"
                  onClick={(e) => handleNavLinkClick(e, "#top_projects")}
                >
                  Projects
                </a>
              </li>
              <li>
                <a
                  href="#about"
                  onClick={(e) => handleNavLinkClick(e, "#about")}
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  onClick={(e) => handleNavLinkClick(e, "#contact")}
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <ul className="nav_icons">
            {socialMedia.map((item, i) => (
              <li key={i}>
                <a href={item.url} target="_blank" rel="noreferrer">
                  {item.icon}
                </a>
              </li>
            ))}
          </ul>
          <div className="menu" onClick={openMenuAnimation}>
            {mobile_menu ? (
              <FaTimes size={24} style={{ color: "var(--highlight-color)" }} />
            ) : (
              <img src={menu} alt="menu" width={30} />
            )}
          </div>
          {/* </div> */}
        </div>
      </nav>

      {mobile_menu && (
        <div className="mobile_menu">
          <ul className="nav_list">
            <li>
              <a
                href="#projects"
                onClick={(e) => handleNavLinkClick(e, "#projects")}
              >
                Projects
              </a>
            </li>
            <li>
              <a href="#about" onClick={(e) => handleNavLinkClick(e, "#about")}>
                About
              </a>
            </li>
            <li>
              <a
                href="#contact"
                onClick={(e) => handleNavLinkClick(e, "#contact")}
              >
                Contact
              </a>
            </li>
            <li className="mobile-social">
              <div className="mobile-social-icons">
                {socialMedia.map((item, i) => (
                  <a key={i} href={item.url} target="_blank" rel="noreferrer">
                    {item.icon}
                  </a>
                ))}
              </div>
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default Navbar;
